import { render, staticRenderFns } from "./handset.vue?vue&type=template&id=1d248b48&scoped=true"
import script from "./handset.vue?vue&type=script&lang=js"
export * from "./handset.vue?vue&type=script&lang=js"
import style0 from "./handset.vue?vue&type=style&index=0&id=1d248b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d248b48",
  null
  
)

export default component.exports